"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigintMin = exports.bigintMax = void 0;
const bigintMax = (a, b) => {
    if (a === undefined) {
        return b;
    }
    if (b === undefined) {
        return a;
    }
    return a > b ? a : b;
};
exports.bigintMax = bigintMax;
const bigintMin = (a, b) => {
    if (a === undefined) {
        return b;
    }
    if (b === undefined) {
        return a;
    }
    return a < b ? a : b;
};
exports.bigintMin = bigintMin;
